import Image from "next/legacy/image";
import React, { useEffect } from "react";
import {
  NewSemesterDescription,
  NewSemesterTitle,
  PageContainer,
  VacationPeriodInfoContainer
} from "./vacation-period.styles";
import { VacationPeriodProps } from "./vacation-period.types";
import trackEvent from "services/mixpanel/mixpanel";
import { vacationPeriodEventNames } from "services/mixpanel/vacation-period-events";

const VacationPeriod: React.FC<VacationPeriodProps> = ({
  title,
  description,
  bgImg
}) => {
  useEffect(() => {
    trackEvent({
      eventName: vacationPeriodEventNames.pageViewed
    });
  }, []);
  return (
    <PageContainer>
      <Image
        alt="vacation-period-bg.png"
        src={bgImg || "/assets/vacation-period/vacation-period-bg.png"}
        layout="fill"
        objectFit="cover"
      />

      <VacationPeriodInfoContainer>
        <NewSemesterTitle dangerouslySetInnerHTML={{ __html: title }} />
        <NewSemesterDescription
          dangerouslySetInnerHTML={{ __html: description }}
        />
      </VacationPeriodInfoContainer>
    </PageContainer>
  );
};

export { VacationPeriod };
